import { z } from "zod";
import { modelSchema } from "../schemas/index.js";
import { generateIdempotencyKey } from "./orders.js";
/**
 * `/auth/models` — labels you file orders under (docs: Models & attribution). Reads need
 * `account:read`; creating needs `trade:execute`. An account may hold up to 50 active models
 * (`409 model_limit_reached`). `model_id` then goes on `POST /auth/orders/buy` (top level), and
 * `GET /auth/opportunities?model_id=…` / `GET /auth/orders?model_id=…` filter by it.
 */
export class ModelsResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /** Your models, newest first. Archived ones are hidden unless asked for. */
    list(params = {}) {
        return this.http.request({
            method: "GET",
            path: "/auth/models",
            endpoint: "models.list",
            query: { status: params.status, include_archived: params.include_archived },
            dataSchema: z.array(modelSchema),
        });
    }
    /** One model, archived included (404 `model_not_found` when it isn't yours). */
    get(id) {
        return this.http.request({
            method: "GET",
            path: `/auth/models/${encodeURIComponent(id)}`,
            endpoint: "models.get",
            dataSchema: modelSchema,
        });
    }
    /** Create a model (201). Writes to the account: call it only when the user acts. */
    create(body, opts = {}) {
        return this.http.request({
            method: "POST",
            path: "/auth/models",
            endpoint: "models.create",
            headers: { "Idempotency-Key": opts.idempotencyKey ?? generateIdempotencyKey() },
            body,
            dataSchema: modelSchema,
        });
    }
}
//# sourceMappingURL=models.js.map